<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <i class="icon-note"></i>
                <strong>{{
                    $t('form.edit', { item: $t('committees.committee') })
                }}</strong>
            </b-card-header>

            <b-card-body>
                <Loader :loader="loader" />
                <Form
                    @onSubmit="onSubmit"
                    :committees="committees"
                    v-show="!loader"
                />
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import api from '@/services/api'
import i18n from '@/i18n'
import Form from './components/Form'
import notification, { success, danger } from '@/lib/notification'
import { mapperCommitteesToAPI } from './mappers/mapperCommitteesToAPI'
import { mapperToOptions as mapperToUsers } from '@/views/components/selects/select-with-avatar'
import { getParam as getUrlParam } from '@/lib/url'
import Loader from '@/views/components/loader'

notification.init()

export default {
    name: 'NewCommittee',
    components: {
        Form,
        Loader,
    },
    data() {
        return {
            loader: true,
            id: getUrlParam('id', this),
            committees: null,
        }
    },
    mounted() {
        api.get(`admin/committees/${this.id}`)
            .then(resp => {
                this.committees = [this.mapperToForm(resp.data.data)]
            })
            .catch(e => {
                console.log(e)
                this.notificationError()
            })
            .finally(() => (this.loader = false))
    },
    methods: {
        mapperToForm(committee) {
            return {
                ...committee,
                users: mapperToUsers(committee.evaluators),
            }
        },
        redirectToList() {
            this.$router.push({ path: '/v2/administrator/committees/list' })
        },
        onSubmit(form, onReset, isLoading) {
            api.put(`admin/committees/${this.id}`, mapperCommitteesToAPI(form))
                .then(() => {
                    onReset()
                    this.notificationCommitteeUpdatedSuccessfully()
                    this.redirectToList()
                })
                .catch(error => {
                    console.log(error)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationCommitteeUpdatedSuccessfully() {
            success(
                i18n.t('notification.updatedSuccessfully', {
                    item: i18n.t('committees.committee'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>
